<template>
    <div class="personal">
        <Nav/>
        <div style="height: 80px"></div>
        <div class="personal-bottom">
            <!-- <div class="personal-bottom-top">
                <div class="personal-bottom-top-div"><div class="personal-bottom-top-div-div"></div><span style="margin-left:25px;">个人中心</span></div>
            </div> -->
            <div class="personal-bottom-bottom">
                <div class="personal-bottom-bottom-left">
                    <slide @change="changeSlide"></slide>
                </div>
                <div class="personal-bottom-bottom-right">
                    <div class="personal-bottom-bottom-right-top">
                        <div>我的位置</div>
                        <el-breadcrumb class="daohang" separator-class="el-icon-arrow-right">
                          <el-breadcrumb-item class="xinxi" :to="{ path: '/personalc?id=0&tab=0' }">
                            <span >我的信息</span>
                          </el-breadcrumb-item>
                          <el-breadcrumb-item class="xinxi">
                            <span >绑定身份证</span>
                          </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="personal-bottom-bottom-right-bottom">
                        <div style="display:flex;">
                            <div>
                                <div style="width:100px;height: 80px;line-height: 50px;">
                                    <span style="color:red;">*</span>
                                    <span >姓名</span>
                                </div>
                                <div style="width:100px;height: 80px;line-height: 50px;">
                                    <span style="color:red;">*</span>
                                    <span >身份证号</span>
                                </div>
                            </div>
                            <div>
                                <div style="height: 80px;"><input v-model="realName" type="text"  placeholder="请输入你的姓名" style="color:#999;box-sizing: border-box;padding-left:15px;outline:none;border:none;outline-color: red;width: 329px;background: #F7F8FA;height: 40px;border-radius: 4px;"></div>
                                <div style="height: 80px;"><input v-model="idCardNum" type="text"  placeholder="请输入身份证号" style="ime-mode:disabled;color:999;box-sizing: border-box;padding-left:15px;outline:none;border:none;outline-color: red;width: 329px;background: #F7F8FA;height: 40px;border-radius: 4px;"></div>
                            </div>
                        </div>
                        <div>
                            <div class="shenfenzheng" style="display:flex;">
                                <el-upload
                                    class="avatar-uploader"
                                    action=""
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccesss"
                                    :before-upload="beforeAvatarUploadd"
                                    :http-request="aa"
                                    name="avatar"
                                    multiple
                                  >
                                  <div v-if="imageUrl" style="position: relative;">
                                      <img :src="imageUrl" class="avatar">
                                      <div style="text-align: center;line-height: 57px;width: 276px;height: 57px;position: absolute;bottom:0;border-radius: 0px 0px 6px 6px;background: rgba(0, 0, 0, 0.5);">重新上传 +</div>
                                  </div>
                                  <div v-else class="avatar-uploader-icon">
                                      <i class="el-icon-plus" style="font-size:80px;margin-top:70px;"></i>
                                      <div style="margin-top:20px;">上传证件人像面</div>
                                  </div>
                                </el-upload>
                                <el-upload
                                    class="avatar-uploader"
                                    action=""
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccesss2"
                                    :before-upload="beforeAvatarUploadd2"
                                    :http-request="aa2"
                                    name="avatar"
                                    multiple
                                  >
                                  <div v-if="imageUrl1" style="position: relative;">
                                      <img :src="imageUrl1" class="avatar">
                                      <div style="text-align: center;line-height: 57px;width: 276px;height: 57px;position: absolute;bottom:0;border-radius: 0px 0px 6px 6px;background: rgba(0, 0, 0, 0.5);">重新上传 +</div>
                                  </div>
                                  <div v-else class="avatar-uploader-icon">
                                      <i class="el-icon-plus" style="font-size:80px;margin-top:70px;"></i>
                                      <div style="margin-top:20px;">上传证件国徽面</div>
                                  </div>
                                </el-upload>
                            </div>
                        </div>
                        <div style="width: 108px;height: 50px;line-height: 50px;font-size:18px;">上传示范案例</div>
                        <div style="display:flex;">
                            <div class="shenfenz_first">
                                <img src="https://oss.ansongqiubo.com/assets/shenfenz.png" alt="">
                            </div>
                            <div style="margin-left:10px;">
                                <div style="display:flex;margin-top:50px;">
                                    <div style="display: flex;justify-content: center;align-items: center;width: 128px;height: 40px;border: 1px solid #DADADA;border-radius: 6px;">
                                        <img src="https://oss.ansongqiubo.com/assets/personimage/duigou.png" alt="">
                                        <span style="margin-left:10px;">四角完璧</span>
                                    </div>
                                    <div style="display: flex;justify-content: center;align-items: center;margin-left:10px;width: 128px;height: 40px;border: 1px solid #DADADA;border-radius: 6px;">
                                        <img src="https://oss.ansongqiubo.com/assets/personimage/duigou.png" alt="">
                                        <span style="margin-left:10px;">照片清晰</span>
                                    </div>
                                </div>
                                <div style="display:flex;margin-top:15px;">
                                    <div style="display: flex;justify-content: center;align-items: center;width: 128px;height: 40px;border: 1px solid #DADADA;border-radius: 6px;">
                                        <img src="https://oss.ansongqiubo.com/assets/personimage/duigou.png" alt="">
                                        <span style="margin-left:10px;">亮度均匀</span>
                                    </div>
                                    <div style="display: flex;justify-content: center;align-items: center;margin-left:10px;width: 128px;height: 40px;border: 1px solid #DADADA;border-radius: 6px;">
                                        <img src="https://oss.ansongqiubo.com/assets/personimage/duigou.png" alt="">
                                        <span style="margin-left:10px;">水平放置</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="display:flex;margin-top:20px;">
                            <div>
                                <img class="no_img" src="https://oss.ansongqiubo.com/assets/queshi.png" alt="">
                                <div style="display: flex;justify-content: center;align-items: center;">
                                    <img  src="https://oss.ansongqiubo.com/assets/cuowu.png" alt="">
                                    <span >边角的缺失</span>
                                </div>
                            </div>
                            <div>
                                <img class="no_img" style="margin-left:25px;" src="https://oss.ansongqiubo.com/assets/zhedang.png" alt="">
                                <div style="margin-left:25px;display: flex;justify-content: center;align-items: center;">
                                    <img  src="https://oss.ansongqiubo.com/assets/cuowu.png" alt="">
                                    <span >信息遮挡</span>
                                </div>
                            </div>
                            <div>
                                <img  class="no_img" style="margin-left:25px;" src="https://oss.ansongqiubo.com/assets/mohu.png" alt="">
                                <div style="margin-left:25px;display: flex;justify-content: center;align-items: center;">
                                    <img src="https://oss.ansongqiubo.com/assets/cuowu.png" alt="">
                                    <span >图片模糊</span>
                                </div>
                            </div>
                            <div>
                                <img class="no_img"  style="margin-left:25px;" src="https://oss.ansongqiubo.com/assets/fanguang.png" alt="">
                                <div style="margin-left:25px;display: flex;justify-content: center;align-items: center;">
                                    <img src="https://oss.ansongqiubo.com/assets/cuowu.png" alt="">
                                    <span >图片反光</span>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top:10px;">
                            <span>1、请上传有效期内身份证原件，要图片清晰、身份证四角齐全、不模糊、不遮盖、不反光。</span><br>
                            <span>2、身份证认证信息必须要和实名认证信息保持一致。</span><br>
                            <span>3、海外用户上传自己合法证件（身份证件、护照）即可。</span><br>
                            <span>4、身份认证信息仅用于提现功能使用，认证信息龙珠会严格保密。</span>
                        </div>
                        <div @click="Tijiao" style="cursor:pointer;margin:0 auto;margin-top:35px;font-weight: 400;line-height: 40px;text-align: center;width: 176px;height: 40px;background: #721EDC;border-radius: 4px;color: #fff;margin-bottom: 20px;">提交</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="tishi1" style="position: fixed;top: calc(50% - 142px/2);left: calc(50% - 248px/2);text-align: center;height: 142px;border-radius: 6px;background-color: rgba(255, 255, 255, 1);width: 248px;">
            <img style="margin-top:30px;" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="">
            <div style="margin-top:20px;">绑定身份证成功</div>
        </div>
        <div v-if="tishi2" style="position: fixed;top: calc(50% - 142px/2);left: calc(50% - 248px/2);text-align: center;height: 142px;border-radius: 6px;background-color: rgba(255, 255, 255, 1);width: 248px;">
            <img style="margin-top:30px;" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="">
            <div style="margin-top:20px;">{{errorMsg}}</div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import slide from './template_slide.vue'
import Nav from '../component/Nav.vue'
export default {
  name: 'App',
  data() {
    return {
        b:0,
        errorMsg:'绑定身份证错误',
        tishi1:false,
        tishi2:false,
        imageUrl: '', //人像面
        imageUrl1:'', //国徽面
        idCardNum:"",//身份证号
        realName:"",//真实姓名
        renxiangshenfenzheng:"",//人像身份证
        guohuishenfenzheng:"",//国徽身份证
        activeName:0
    }
  },
  mounted(){
    this.$axios({
        url:this.api+'/v1/profile/bind',
        method:'GET',
        headers: {
          "device": "web",
          "packageId": "1",
          "version": "1.0.0",
          "channel":"web",
          "authToken":localStorage.getItem('token'),
          "Content-Type": "application/json"
        },
        }).then(res =>{
          console.log(res);
        })
  },
  methods:{
    changeSlide(data){
      this.$router.push(data);
    },
    aa(e){
        var file = e.file
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let fileResult = "";
            reader.readAsDataURL(file);
            //开始转
            reader.onload = function() {
              fileResult = reader.result;
            };
            //转 失败
            reader.onerror = function(error) {
              reject(error);
            };
            //转 结束  咱就 resolve 出去
            reader.onloadend = function() {
              resolve(fileResult);
            };
        });
    },
    handleAvatarSuccesss(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.renxiangshenfenzheng = res;
    },
    beforeAvatarUploadd(file) {
      this.file = file;
      const isJPG = file.type === 'image/png';
      const isJPG2 = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG&&!isJPG2) {
        this.$message.error('上传图片只能是JPG或者png格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG2 || isJPG && isLt2M;
    },

    //国像面身份证
    aa2(e){
        var file = e.file
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let fileResult = "";
            reader.readAsDataURL(file);
            //开始转
            reader.onload = function() {
              fileResult = reader.result;
            };
            //转 失败
            reader.onerror = function(error) {
              reject(error);
            };
            //转 结束  咱就 resolve 出去
            reader.onloadend = function() {
              resolve(fileResult);
            };
        });
    },
    handleAvatarSuccesss2(res, file) {
        this.imageUrl1 = URL.createObjectURL(file.raw);
        this.guohuishenfenzheng = res;
    },
    beforeAvatarUploadd2(file) {
    this.file = file;
      const isJPG = file.type === 'image/png';
      const isJPG2 = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG&&!isJPG2) {
        this.$message.error('上传图片只能是JPG或者png格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG2 || isJPG && isLt2M;
    },

    dianji(e){
      this.b =e;
    },
    aletMsg(val){
      this.errorMsg = val;
      this.tishi2 = true;
      setTimeout(() => {
        this.tishi2 = false;
      }, 2000);
    },
    ruleQuery(){
        if(!this.realName){
          this.aletMsg('姓名不能为空');
          return false
        }
        if(!this.idCardNum){
          this.aletMsg('身份证不能为空');
          return false
        }
        if(!this.renxiangshenfenzheng){
          this.aletMsg('身份证正面不能为空');
          return false
        }
        if(!this.guohuishenfenzheng){
          this.aletMsg('身份证反面不能为空');
          return false
        }
        return true
    },
    Tijiao: function() {
      let state  = this.ruleQuery();
      if(!state){
        return
      }
        this.$axios({
            headers: {
              "device": "web",
              "packageId": "1",
              "version": "1.0.0",
              "channel":"web",
              "authToken":localStorage.getItem('token'),
              "Content-Type": "application/x-www-form-urlencoded"
            },
            transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
              data = qs.stringify(data)
              return data
            }],
            url:this.api+'/v1/profile/bind/idcard',
            method:'post',
            data:{
                realName:this.realName,
                idCardNum:this.idCardNum,
                frontUrl:this.renxiangshenfenzheng,
                backUrl:this.guohuishenfenzheng
            }
        }).then(res =>{
            console.log(res);
            if (res.data.message == "success") {
                this.tishi1 = true
                setTimeout(()=>{
                    this.tishi1 = false
                    this.$router.push('/personalc')
                },2000)
            }else{
                this.aletMsg(res.data.message)
            }
        })

    }
  },
  components:{
    Nav,
    slide
  }
}
</script>
<style>

    .xzcxzcxz{
        color: white;
    }
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
    .personal-bottom-bottom-left .el-collapse-item__content{
        padding-bottom: 0px;
    }
    .personal-bottom-bottom-left .el-collapse-item__wrap{
        border-bottom:0px solid #EBEEF5;
    }
    .personal-bottom-bottom-left .el-collapse-item__content > div{
        text-align: center;
    }
    .personal-bottom-bottom-left .is-active{
      color: #721EDC;
    }
    .personal-bottom-bottom-left .el-collapse{
        border-top: 0px solid #EBEEF5;
        width: 100%;
    }

    .personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
</style>
<style scoped lang='scss'>
.sanjiao{

    width: 0;
    height:0;
    border-top: 11px solid #ffffff;
    /* border-bottom-width: 11px; */
    /* border-radius: 0px; */
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    margin: 0 auto;
    margin-top: 15px;
}
.a {
  background-color: #721edc;
}
.xzcxzcxz {
  color: white;
}
.shenfenz_first{
    width: 312px;
    height: 211px;
    img{
         width: 312px;
    height: 211px;
    }
}
.no_img{
    width: 129px;
    height: 87px;
}
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}

.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px 0 20px;
  box-sizing: border-box;
  margin-top: 16px;
}
.personal-bottom-bottom-right-top {
  background-color: #fff;
  display: flex;
  align-items: center;
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}

.personal-bottom-bottom-right-bottom{
    height: calc(94% - 15px);
     margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
    position: relative;
    box-sizing: border-box;
}
.daohang{
    display: flex;
    color: white;
    width: 500px;
    margin-left: 20px;
}
.xinxi{
    display: flex;
    align-items: center;
    font-size: 16px;
}
.biao{
    width: 16px;
    height: 16px;
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao{
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.a{
    background-color: #721EDC;
}
</style>
<style>
    .shenfenzheng .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      margin-left: 20px;
    }
    .shenfenzheng .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .shenfenzheng .avatar-uploader-icon {
      /* font-size: 16px; */
      color: #8c939d;
      width: 276px;
      height: 276px;
      /* line-height: 178px; */
      text-align: center;
    }
    .shenfenzheng .avatar {
      width: 276px;
      height: 276px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/component/BangdingIdentity.vue